import React from 'react';
import Banner from "./Banner"
import SlidingText from './SlidingText';
import EventDirection from './EventDirection';
import GalleryOne from './GalleryOne';
import ScheduleOne from './ScheduleOne';
import FeatureOne from './FeatureOne';


const HomeMain = () => {
	return (
		<React.Fragment>

			{/* Schema Markup */}
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: JSON.stringify(
				{
				"@context": "https://schema.org",
				"@type": "Organization",
				"name": "RSVPPASS",
				"image": "https://www.rsvppass.com/rsvp_logo.png",
				"url": "https://www.rsvppass.com",
				"telephone": "+1-619-555-1234",
				"email": "info@rsvppass.com",
				"address": {
					"@type": "PostalAddress",
					"streetAddress": "123 Event Street",
					"addressLocality": "San Diego",
					"addressRegion": "CA",
					"postalCode": "92101",
					"addressCountry": "US"
				},
				"openingHours": "Mo-Fr 09:00-17:00",
				"priceRange": "$",
			
				"description": "Discover the best events and nightlife worldwide! Find exclusive event promo codes, music festivals, parties, concerts, and more. Your ultimate guide to exciting events near you and around the globe.",
				"founder": {
					"@type": "Person",
					"name": "Erik Avery"
				},
				"foundingDate": "2001",
				"department": {
					"@type": "Organization",
					"name": "RSVPPASS",
					"url": "https://www.rsvppass.com/about"
				}
				}
				) }}
				/>


			<Banner />
			<FeatureOne />
			<SlidingText />
			<ScheduleOne />
			<EventDirection />
			<GalleryOne />
		</React.Fragment>
	);
}

export default HomeMain;